import { DataSource, DataSourceType } from "@coeff/api";
import React, { ReactNode } from "react";

import { AuthorizeSQLContent } from "../../auth/connectors/sql/AuthorizeSQLContent";
import { useAuthContext } from "../../auth/context/AuthContext";

type Props = {
  dataSourceType: DataSourceType;
  customDescription?: ReactNode;
  isPPressComponent?: boolean;
  useSecondaryForm?: boolean;
};

/**
 * PPress-namespace wrapper for AuthorizeSQL.
 *
 * The backend auth form JSX renders `<PPress.AuthorizeSQL dataSourceType="databricks" />`
 * with no callbacks, so this wrapper pulls everything else (post-creation hook, upsert
 * navigation, cancel) from the shared AuthContext that the host provides.
 */
export const AuthorizeSQL: React.FC<Props> = ({
  dataSourceType,
  customDescription,
  isPPressComponent,
  useSecondaryForm,
}) => {
  const {
    navigateOnDataSourceUpsert,
    initPostDataSourceCreation,
    router,
    renderConnectionHelpCard,
    dataSource,
  } = useAuthContext();

  return (
    <AuthorizeSQLContent
      dataSourceType={dataSourceType}
      dataSource={dataSource}
      customDescription={customDescription}
      isPPressComponent={isPPressComponent ?? true}
      useSecondaryForm={useSecondaryForm}
      initPostDataSourceCreation={
        initPostDataSourceCreation ?? (({ dataSource, onComplete }) => onComplete(dataSource))
      }
      onDataSourceUpserted={(dataSource: DataSource) => navigateOnDataSourceUpsert?.(dataSource)}
      onCancel={() => router?.back?.()}
      renderConnectionHelpCard={renderConnectionHelpCard}
    />
  );
};
